import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePhaseTaskComponent } from './changePhaseTask.component';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DropdownModule } from 'primeng-lts/dropdown';

@NgModule({
  declarations: [ChangePhaseTaskComponent],
  imports: [TranslateModule, CommonModule, CheckboxModule, FormsModule, RouterModule, DropdownModule]
})
export class ChangePhaseTaskModule { }
